(() => {
  if (window.PlaidGalleryInitialized) return;
  window.PlaidGalleryInitialized = true;

  const galleries = document.querySelectorAll('[data-plaid-gallery]');
  if (!galleries.length) return;

  for (const gallery of galleries) {
    const track = gallery.querySelector('[data-plaid-gallery-track]');
    const source = gallery.querySelector('[data-plaid-gallery-source]');
    const empty = gallery.querySelector('[data-plaid-gallery-empty]');
    const dialog = gallery.querySelector('[data-plaid-gallery-dialog]');
    const enlarged = dialog.querySelector('[data-plaid-gallery-enlarged]');
    const count = dialog.querySelector('[data-plaid-gallery-count]');
    const previous = dialog.querySelector('[data-plaid-gallery-previous]');
    const next = dialog.querySelector('[data-plaid-gallery-next]');
    const close = dialog.querySelector('[data-plaid-gallery-close]');
    let slides = [];
    let activeIndex = 0;
    let opener = null;
    let swipeStart = null;

    function loadVisibleImages() {
      const images = track.querySelectorAll('img[data-src]');
      images.forEach((image, index) => {
        if (index < 2) {
          image.src = image.dataset.src;
          image.loading = index === 0 ? 'eager' : 'lazy';
          delete image.dataset.src;
        } else if ('IntersectionObserver' in window) {
          observer.observe(image);
        } else {
          image.src = image.dataset.src;
          image.loading = 'lazy';
          delete image.dataset.src;
        }
      });
    }

    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const image = entry.target;
            image.src = image.dataset.src;
            image.loading = 'lazy';
            delete image.dataset.src;
            observer.unobserve(image);
          });
        }, { root: track, rootMargin: '200px' })
      : null;

    function setColor(color) {
      if (!color) return;
      if (observer) observer.disconnect();
      const matching = [...source.content.querySelectorAll('[data-plaid-gallery-color]')]
        .filter((slide) => slide.dataset.plaidGalleryColor === color);
      // Keep server-rendered photos if a translated color cannot be matched.
      if (!matching.length) return;
      const reuseInitial = track.hasAttribute('data-plaid-gallery-server-rendered') && gallery.dataset.color === color;
      if (!reuseInitial) track.replaceChildren(...matching.map((slide) => slide.cloneNode(true)));
      track.removeAttribute('data-plaid-gallery-server-rendered');
      slides = [...track.querySelectorAll('[data-plaid-gallery-open]')];
      gallery.dataset.color = color;
      gallery.setAttribute('aria-label', /^ja(?:-|$)/i.test(document.documentElement.lang) ? `${color}のブランケットの商品画像` : /^it(?:-|$)/i.test(document.documentElement.lang) ? `Immagini della coperta ${color}` : /^pl(?:-|$)/i.test(document.documentElement.lang) ? `Zdjęcia koca ${color}` : `Photos du plaid ${color}`);
      empty.hidden = slides.length > 0;
      track.scrollLeft = 0;
      activeIndex = 0;
      loadVisibleImages();
      if (dialog.open) dialog.close();
    }

    function showImage(index) {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      const image = slides[activeIndex].querySelector('img');
      enlarged.src = image.dataset.zoomSrc || image.src;
      enlarged.alt = image.alt;
      count.textContent = `${activeIndex + 1} / ${slides.length}`;
      previous.hidden = slides.length < 2;
      next.hidden = slides.length < 2;
    }

    track.addEventListener('click', (event) => {
      const button = event.target.closest('[data-plaid-gallery-open]');
      if (!button || !track.contains(button)) return;
      opener = button;
      showImage(slides.indexOf(button));
      dialog.showModal();
      close.focus();
    });

    previous.addEventListener('click', () => showImage(activeIndex - 1));
    next.addEventListener('click', () => showImage(activeIndex + 1));
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(activeIndex + 1);
      }
    });
    dialog.addEventListener('close', () => {
      enlarged.removeAttribute('src');
      opener?.focus();
    });
    dialog.addEventListener('pointerdown', (event) => {
      swipeStart = { x: event.clientX, y: event.clientY };
    });
    dialog.addEventListener('pointerup', (event) => {
      if (!swipeStart) return;
      const dx = event.clientX - swipeStart.x;
      const dy = event.clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        showImage(activeIndex + (dx < 0 ? 1 : -1));
      }
    });

    document.addEventListener('plaid:variant-change', (event) => {
      const color = event.detail?.color;
      if (color && color !== gallery.dataset.color) setColor(color);
    });
    setColor(gallery.dataset.color);
  }
})();
